<template>
    <div class="py-8 bg-gray-50">

        <div class="px-4 mx-auto max-w-8xl">
            <h2 v-if="mainHeading" class="mb-2 font-bold tracking-tight text-center md:font-extrabold lg:mb-3 textp font-ww-medium" v-html="mainHeading"></h2>

            <div class="text-center text-gray-500 textp lg:px-20" v-html="paragraph"></div>
        </div>

    </div>
</template>

<script setup>
const props = defineProps({
    mainHeading: {
        type: String,
        default: 'FDA warning'
    },
    paragraph: {
        type: String,
        default: '*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.'
    },
});

defineBuilderComponent({
    friendlyName: "FDA Warning",
    inputs: [
        {
            name: 'mainHeading',
            type: 'richText',
            defaultValue: 'FDA warning'
        },
        {
            name: 'paragraph',
            type: 'richText',
            defaultValue: '*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.'
        },
    ]
});
</script>